import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientsComponent } from './clients/clients.component';
import { ConfigurationsRoutingModule } from './configurations-routing.module';
// 3rd party
import { RxReactiveDynamicFormsModule } from '@rxweb/reactive-dynamic-forms';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { NgxLoadingModule } from 'ngx-loading';
// Modules
import { SharedModule } from '../../../shared/shared.module';
// Components
import { FormService } from '../../../shared/services/form.service';
import { CreateEditClientsComponent } from './clients/create-edit-clients/create-edit-clients.component';
import { ConfigMediasComponent } from './config-medias/config-medias.component';
import { CreateEditCategoryComponent } from './config-medias/create-edit-category/create-edit-category.component';
import { RolesControllerComponent } from './roles-controller/roles-controller.component';
import { CreateEditRolesControllerComponent } from './roles-controller/create-edit-roles-controller/create-edit-roles-controller.component';
import { PermissionsControllerComponent } from './permissions-controller/permissions-controller.component';
import { CreateEditPermissionsControllerComponent } from './permissions-controller/create-edit-permissions-controller/create-edit-permissions-controller.component';
import { ProfileComponent } from './profile/profile.component';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DesignReelsComponent } from './design-reels/design-reels.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LoadingModalComponent } from '../../../shared/modal/loading-modal/loading-modal.component';

@NgModule({
    declarations: [
        ClientsComponent,
        CreateEditClientsComponent,
        ConfigMediasComponent,
        CreateEditCategoryComponent,
        RolesControllerComponent,
        CreateEditRolesControllerComponent,
        PermissionsControllerComponent,
        CreateEditPermissionsControllerComponent,
        ProfileComponent,
        DesignReelsComponent
    ],
    imports: [
        CommonModule,
        RxReactiveFormsModule,
        RxReactiveDynamicFormsModule,
        SharedModule,
        ConfigurationsRoutingModule,
        FormsModule,
        InputSwitchModule,
        ButtonModule,
        DragDropModule
    ],
    providers: [
        FormService
    ]
})
export class ConfigurationsModule { }
